'use client'
import { useEffect, useRef } from 'react'

import Shared from '@/shared'
import Button from '@/shared/components/button/Button'
import Icons from '@/shared/components/icon/Icons'
import { Text } from '@/shared/components/typography'
import Caption from '@/shared/components/typography/Caption'

interface ParkinglotMapInfoProps {
  parkinglotName: string
  parkinglotAddress: string
  onClick: () => void
  onClickNaviBtn: () => void
}

function ParkinglotMapInfo({ parkinglotName, parkinglotAddress, onClick, onClickNaviBtn }: ParkinglotMapInfoProps) {
  const ref = useRef<null | HTMLDivElement>(null)
  const setBottomSheetYPosition = Shared.States.useMapLayoutPositions((state) => state.setBottomSheetYPosition)

  useEffect(() => {
    let bottomSheetEl: null | HTMLDivElement = null
    if (ref.current == null) return
    bottomSheetEl = ref.current
    const y = bottomSheetEl.getBoundingClientRect().y
    setBottomSheetYPosition(y)
  }, [ref.current])

  return (
    <div className={`absolute bottom-0 left-0 z-20 flex w-full flex-col`} ref={ref}>
      <div className="flex w-full flex-col justify-center bg-010 px-[16px] pb-4 pt-6">
        <Text level="text2" color="text090" weight="medium" className="mb-[8px]">
          {parkinglotName}
        </Text>
        <div className={`flex ${parkinglotAddress ? 'flex' : ' flex-col gap-[20px]'}`}>
          <Caption level="caption1" color="text070" weight="regular">
            {parkinglotAddress ? parkinglotAddress : '상세 위치는 내비게이션 또는 지도를 확인해 주세요.'}
          </Caption>
          {parkinglotAddress && (
            <div className="ml-[4px] h-[18px] w-[18px] cursor-pointer" onClick={onClick}>
              <Icons.CopyIcon stroke="currentColor" color="#6D7D90" />
            </div>
          )}
          {!parkinglotAddress && (
            <Button
              text="내비게이션"
              color="text010"
              background="bg030"
              className="body-1"
              disabled={false}
              pyValue="py-[13px]"
              onClick={onClickNaviBtn}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ParkinglotMapInfo
